exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @prettier\n */\n@media screen and (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n.previewBox___2u4jL {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  height: 100%;\n  justify-content: space-around;\n  margin: auto;\n  width: 100%;\n}\n.colorPickerBox___2ssUz {\n  margin: 20px auto 0 auto;\n}\n.centeredBox___16GYb {\n  align-items: center;\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n}\n@media (max-width: 767px) {\n  .centeredBox___16GYb {\n    display: block;\n    flex: none;\n  }\n}\n.imageLayer___3tKlj {\n  background-repeat: no-repeat;\n  background-size: 100%;\n  position: absolute;\n}\n.textLayer___1le12 {\n  position: absolute;\n}\n.canvas___JYMHL {\n  position: relative;\n  transform-origin: left top;\n}\n.canvasBox___1olSD {\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);\n}\n.box___3GlQl {\n  align-items: center;\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n}\n.nonEditableImg___1OM0A {\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);\n  width: 280px;\n}\n", ""]);

// exports
exports.locals = {
	"previewBox": "previewBox___2u4jL",
	"colorPickerBox": "colorPickerBox___2ssUz",
	"centeredBox": "centeredBox___16GYb",
	"imageLayer": "imageLayer___3tKlj",
	"textLayer": "textLayer___1le12",
	"canvas": "canvas___JYMHL",
	"canvasBox": "canvasBox___1olSD",
	"box": "box___3GlQl",
	"nonEditableImg": "nonEditableImg___1OM0A"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/SingleSample/SamplePreview/styles.module.less
// module id = 1626
// module chunks = 51